module.exports = __webpack_public_path__ + "static/media/notify-when-available-phone.e0f2225a.png";